import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Markets from "@/pages/Markets";
import CommodityDetail from "@/pages/CommodityDetail";
import Alerts from "@/pages/Alerts";
import Notes from "@/pages/Notes";
import Vendors from "@/pages/Vendors";
import Pricing from "@/pages/Pricing";
import EmailInbox from "@/pages/EmailInbox";
import Bundle from "@/pages/Bundle";
import Simulator from "@/pages/Simulator";
import AnalystChat from "@/pages/AnalystChat";
import { useEffect } from "react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function ThemeBoot() {
  useEffect(() => {
    const t = localStorage.getItem("agri_theme");
    // dark default
    document.documentElement.classList.toggle("dark", t !== "light");
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeBoot />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/markets" element={<Protected><Markets /></Protected>} />
          <Route path="/app/alerts" element={<Protected><Alerts /></Protected>} />
          <Route path="/app/notes" element={<Protected><Notes /></Protected>} />
          <Route path="/app/vendors" element={<Protected><Vendors /></Protected>} />
          <Route path="/app/pricing" element={<Protected><Pricing /></Protected>} />
          <Route path="/app/emails" element={<Protected><EmailInbox /></Protected>} />
          <Route path="/app/simulator" element={<Protected><Simulator /></Protected>} />
          <Route path="/app/analyst-chat" element={<Protected><AnalystChat /></Protected>} />
          <Route path="/app/bundles/:key" element={<Protected><Bundle /></Protected>} />
          <Route path="/commodity/:code" element={<Protected><CommodityDetail /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
